import React from "react";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import { StyledInputTime } from "./styles/Inputs";

const InputTime = ({
  label,
  value,
  setValue,
  helperText,
  error = false,
  onChange = (e) => {
    setValue(e);
  },
  margin = "normal",
  ...props
}) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <StyledInputTime
        {...props}
        size="small"
        margin={margin}
        label={label}
        value={value}
        onChange={onChange}
        helperText={helperText}
        error={error}
        KeyboardButtonProps={{
          "aria-label": "change time",
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

export default InputTime;
